import { render } from "./PlayerItem.vue?vue&type=template&id=7235faef&scoped=true"
import script from "./PlayerItem.vue?vue&type=script&lang=js"
export * from "./PlayerItem.vue?vue&type=script&lang=js"

import "./PlayerItem.vue?vue&type=style&index=0&id=7235faef&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7235faef"

export default script